<template>
  <div class="banner">
    <div class="container h-100">
      <div class="row h-100 justify-content-between align-items-end">
        <!-- Columna 1 -->
        <div class="col-1 col-lg-3 d-none d-lg-block position-relative">
          <img
            src="@/core/assets/images/businesses/banner-1.png"
            alt="Imagen de banner"
            class="image-1 d-none d-lg-block"
          />
        </div>

        <!-- Columna 2 -->
        <div class="col-2 col-lg-3 d-none d-lg-flex align-items-end position-relative px-0">
          <img
            src="@/core/assets/images/businesses/banner-2.png"
            alt="Imagen de banner"
            class="image-2 d-none d-lg-block"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AdminBanner"
};
</script>

<style lang="stylus" scoped>
@import "../Styles/banner";
</style>
